import Heading from './Heading';
import withHtmlSafe from '../withHtmlSafe';
export default withHtmlSafe(Heading);